export var DisplayUsernamesConfigurations = {
  FIRSTNAME_LASTNAME_SAME_COLUMN: 'FIRSTNAME_LASTNAME_SAME_COLUMN',
  LASTNAME_FIRSTNAME_SAME_COLUMN: 'LASTNAME_FIRSTNAME_SAME_COLUMN',
  FIRSTNAME_LASTNAME_TWO_COLUMNS: 'FIRSTNAME_LASTNAME_TWO_COLUMNS',
  LASTNAME_FIRSTNAME_TWO_COLUMNS: 'LASTNAME_FIRSTNAME_TWO_COLUMNS'
};